import { get } from 'lodash';
import { RcCorporeal } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { getVictimDetails } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import { REGULATIONS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import {
  PARTIAL_JUGEMENT,
  RELIQUAT_APPEL,
  RELIQUAT_JUGEMENT,
  TOTAL_JUGEMENT,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/constants';
import { translate } from 'containers/services/translate';

export const getBeneficiaries = (
  rcCorpo: RcCorporeal,
  sagisClaim: any,
  corpoEncryptedDocumentsResult: any,
  paymentStatus: SagisConfig[],
  forMinors: boolean,
) => {
  const victimModel = getVictimDetails(
    rcCorpo,
    sagisClaim,
    corpoEncryptedDocumentsResult,
    paymentStatus,
  );
  const result = victimModel
    .filter(item => (forMinors ? item?.minor : !item?.minor))
    .map((item: any) => {
      if (!!get(item, 'nextOfKinKey')) return get(item, 'nextOfKinName', '');
      else {
        return get(item, 'victimName', '');
      }
    })
    .flat();
  return result.join(' - ');
};
/* istanbul ignore next */
export const getCnraTitle = (
  props: any,
  rcCorpo: any,
  listings: Listings,
  messages: any,
) => {
  const natureCode = get(
    rcCorpo.regulationInfo,
    REGULATIONS.REGULATION_NATURE,
    '',
  );
  const encryptDocumentNature = get(listings, 'EncryptDocumentNature', []).find(
    (item: SagisConfig) => item?.ItemKey === natureCode,
  );
  return get(encryptDocumentNature, 'ItemKey', '') === RELIQUAT_JUGEMENT ||
    get(encryptDocumentNature, 'ItemKey', '') === RELIQUAT_APPEL
    ? translate(messages.cnraRemainder, props)
    : (get(encryptDocumentNature, 'ItemKey', '') === PARTIAL_JUGEMENT ||
        get(encryptDocumentNature, 'ItemKey', '') === TOTAL_JUGEMENT) &&
        translate(messages.cnraProvisionalExecution, props);
};
